<template>
  <nd-dialog
    v-model="visible"
    class="detention-dialog"
    :footer="false"
  >
    <div class="detention-content">
      <div class="header">
        <p>填写简单的信息，最高即可获得</p>
        <p>5万额度！真的要放弃吗？</p>
      </div>
      <ul class="body">
        <li
          v-for="(item, index) in giveUpReason"
          :key="index"
          @click="giveUp(index + 1)"
        >
          {{ item }}
        </li>
      </ul>
      <button
        class="footer"
        @click="visible=false"
      >
        继续完成，拿额度
      </button>
    </div>
  </nd-dialog>
</template>

<script>
export default {
  name: 'Detention',
  data () {
    return {
      giveUpReason: ['我再逛逛', '放弃免费额度']
    }
  },
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    visible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    giveUp (index) {
      if (index === 2) {
        this.$router.replace('/landing/h5-credit')
      } else {
        this.visible = false
      }
    }
  }
}
</script>
<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.detention-dialog {
  .detention-content {
    width: 620px;
    background: rgba(255, 255, 255, 1);
    border-radius: 30px;
    overflow: hidden;
    .header {
      margin: 0px 0 45px;
      font-size: 36px;
      font-weight: 500;
      font-family: PingFangSC-Medium, PingFang SC;
      color: rgba(51, 51, 51, 1);
      line-height: 50px;
      text-align: center;
    }

    .body {
      li {
        height: 110px;
        line-height: 110px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        font-size: 30px;
        color: #999;
        text-align: center;
        border-bottom: 1px solid #eee;
        &:first-child {
          border-top: 1px solid #eee;
        }
      }
    }

    .footer {
      display: block;
      margin: 55px auto;
      border: 0px solid transparent;
      font-family: PingFangSC-Medium, PingFang SC;
      font-size: 36px;
      font-weight: 600;
      color: #ff4633;
      text-align: center;
      outline: none;
      background-color: #ffffff;
    }
  }
}
</style>